<ng-container>
	<div class="ontop">
		<mat-form-field appearance="outline" color="accent">
			<mat-label>Address Search</mat-label>
			<input type="text" matInput value="" [(ngModel)]="addressAutocompleteInput" #addresstext (keyup.enter)="$event.preventDefault(); $event.stopPropagation()">
		</mat-form-field>
	</div>
</ng-container>
